// import React from 'react'
// import s1 from "../assets/s1.png";
// import fe1 from "../assets/fe1.png";
// import fe2 from "../assets/fe2.png";
// import fe3 from "../assets/fe3.png"; 
// import PhoneHeader from "./PhoneHeader";

// const AadhaarPay = () => {
//   const data = [
//     {
//       title: "Financial Inclusion",
//       text: "Brings banking to remote or rural areas without branches."
//     },
//     {
//       title: "Secure & Reliable",
//       text: "Uses Aadhaar authentication, reducing fraud risk."
//     },
//     {
//       title: "No Card Required",
//       text: "Works without debit/credit cards or smartphones in some cases."
//     },
    
//   ];
//   return (
//     <>
//     <PhoneHeader title="Aadhaar Pay" className="d-md-none d-block" />
//        <div className="container-fluid d-md-block d-none">
//         <div
//           className="text-center top-heading section"
//         >
//           <h1>Aadhaar Pay</h1>
//         </div>
//       </div>
//       <div className="container">
//        <div className="row section align-items-center">
//           <div className="col-12 col-md-6 mb-3 mb-md-0">
//             <h1>
//               <strong>Overview</strong>
//             </h1>
//           </div>

//           <div className="col-12 col-md-6">
//             <p>
//               <strong style={{ color: "#FF7A60", fontSize: "26px" }}>O</strong>
//               ur platform supports digital payments via UPI along with cash
//               access through Micro ATMs — giving customers flexibility to go
//               cashless or withdraw cash conveniently. Based on PaymentHub’s
//               service model
//             </p>
//           </div>
//         </div>

//         <div className="section">
//           <img src={s1} className="w-100" />
//         </div>      

//            <div className="row g-4 justify-content-center text-center">
//              <h2 className='mt-4 mb-5' style={{textAlign:"center",fontWeight:"600"}}>Features</h2>

//         {/* Card 1 */}
//         <div className="col-12 col-sm-6 col-md-4">
//           <div className="p-4 h-100 rounded-4" style={{ backgroundColor: "#FFDED3" }}>
//             <img src={fe1} alt="Biometric Authentication" className="mb-3 img-fluid" />
//             <h5 className="fw-semibold">Biometric-based authentication — fingerprint or iris.</h5>
//             <p>GST registration & return filing <br /> paymenthub</p>
//           </div>
//         </div>

//         {/* Card 2 */}
//         <div className="col-12 col-sm-6 col-md-4">
//           <div className="p-4 h-100 rounded-4" style={{ backgroundColor: "#E0FBFF" }}>
//             <img src={fe2} alt="Aadhaar-linked accounts" className="mb-3 img-fluid" />
//             <h5 className="fw-semibold">Works with Aadhaar-linked bank accounts.</h5>
//             <p>Income tax return (ITR) filing <br /> paymenthub.</p>
//           </div>
//         </div>

//         {/* Card 3 */}
//         <div className="col-12 col-sm-6 col-md-4">
//           <div className="p-4 h-100 rounded-4" style={{ backgroundColor: "#EBF4E7" }}>
//             <img src={fe3} alt="Instant processing" className="mb-3 img-fluid" />
//             <h5 className="fw-semibold">Instant payment processing.</h5>
//             <p>Set up, manage, and maintain your <br /> infrastructure.</p>
//           </div>
//         </div>

//       </div>

//          {/* benefits */}
//        <div className="section d-none d-md-block">
//           <h2 className="text-center fw-bold mb-5">Benefits</h2>

//           <div className="benefits-wrapper position-relative">
//             <div className="benefit"></div>
//             <div className="center-line"></div>

//             <div className="row align-items-center mb-5">
//               <div className="col-6 text-end">
//                 <div className="benefit-card">
//                   <h5 className="fw-bold text-start mb-3">Professional help to navigate legal processes.</h5>
//                   <p className="text-start">
// One-stop bill payment portal for multiple services.                  </p>
//                 </div>
//               </div>
//               <div className="col-6"></div>
//             </div>

//             <div className="row align-items-center mb-5">
//               <div className="col-6"></div>
//               <div className="col-6">
//                 <div className="benefit-card-1">
//                   <h5 className="fw-bold mb-3">Saves time and cost with expert support..</h5>
//                   <p>Backed by established payment network.</p>
//                 </div>
//               </div>
//             </div>

//             <div className="row align-items-center mb-5">
//               <div className="col-6 text-end">
//                 <div className="benefit-card">
//                   <h5 className="fw-bold text-start mb-3">Affordable service suited for small businesses, retailers, or agents.</h5>
//                   <p className="text-start">
//                     Agents can facilitate bill payments and earn fees. (Modelled like PaymentHub)
//                   </p>
//                 </div>
//               </div>
//               <div className="col-6"></div>
//             </div>
//           </div>
//         </div>
//         <div className="section d-md-none d-block">
//           <h2 className="text-center fw-bold mb-5">Benefits</h2>

//           <div className="row justify-content-center">
//             {data.map((item, index) => (
//               <div className="col-12 mb-3" key={index}>
//                 <div className="benefit-box text-center p-4">
//                   <h5 className="mb-2" style={{fontWeight:"700"}}>{item.title}</h5>
//                   <p className="mb-0">{item.text}</p>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>
//     </>
//   )
// }

// export default AadhaarPay
import React from "react";
import s1 from "../assets/s1.png";
import PhoneHeader from "./PhoneHeader";
import benfits from "../assets/benfites.jpg";

const AadhaarPay = () => {
  
  return (
    <>
      <PhoneHeader title="AEPS Service" className="d-md-none d-block" />

      {/* <div className="container-fluid d-md-block d-none">
        <div className="text-center top-heading section">
          <h1>AEPS Service</h1>
        </div>
      </div> */}
      <div className="container space">
        <div className="text-center top-heading section">
          <h1 className="mb-0">Aadhaar Pay Services</h1>
        </div>
        <div className="row section align-items-center">
          <div className="col-12 col-md-7">
            <div className="">
              <h1>  
                <strong>Overview</strong>
              </h1>
            </div>
            <p>
              {/* <strong style={{ color: "#FF7A60", fontSize: "26px" }}>A</strong> */}
              Aadhaar Pay is a digital payment solution that allows customers to make secure and cashless payments using their Aadhaar number and biometric authentication. It is specially designed to support individuals who may not carry a debit card or smartphone. Integrated with AEPS, Aadhaar Pay enables retailers to accept payments directly from a customer’s bank account with just a fingerprint or iris scan.
            </p>
            <ul className="list-unstyled mb-4 mb-md-0">
              <h5 className="fw-bold mt-2 mb-3">How Aadhaar Pay Works</h5>
              <li className="mb-2">
                • The customer simply provides their Aadhaar number, selects their bank
              </li>
              <li className="mb-2">
                • Authenticates the payment using their fingerprint on a biometric device
              </li>
              <li className="mb-2">
                • The amount is instantly transferred to the retailer’s account, and a confirmation receipt is generated.
              </li>
            </ul>
          </div>
          <div className="col-12 col-md-5 mb-3 mb-md-0">
            <div className="">
              <img src={s1} className="w-100 m-auto img-holl" />
            </div>
          </div>
        </div>

         <div className="section key-features align-items-center py-md-5 p-4">
          {/* HEADING */}
          <h2 className="fw-bold text-center mb-4">Benefits for Retailers & AEPS Operators</h2>

          <div className="row">
            {/* IMAGE */}
            <div className="col-12 col-md-5  text-center pb-4 pb-md-0">
              <img
                src={benfits}
                alt="Key Features"
                className="img-fluid img-holl"
                style={{ maxWidth: "100%", width: "100%"}}
              />
            </div>

            {/* FEATURE LIST */}
            <div className="col-12 col-md-7 m-auto">
              <ul
                className="list-unstyled mx-auto"
              >
                <li className=" mb-3">• Accept payments from any bank account</li>
                <li className=" mb-3">• Increase customer footfall </li>
                <li className=" mb-3">• Earn attractive commissions</li>
                <li className=" mb-3">• Zero setup cost</li>
                <li className="mb-3">• Fast, secure, and hassle-free </li>
                <li className="">• Boost credibility  </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AadhaarPay;
